/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SearchOptionDTO } from '../models/SearchOptionDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SearchOptionsControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param source
     * @param version
     * @param searchValue
     * @returns SearchOptionDTO OK
     * @throws ApiError
     */
    public getSearchOptions(
        source: string,
        version: string,
        searchValue?: string,
    ): CancelablePromise<Array<SearchOptionDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/search-options/{source}/{version}',
            path: {
                'source': source,
                'version': version,
            },
            query: {
                'searchValue': searchValue,
            },
        });
    }
}
